import { CSSObject } from '@chakra-ui/react';

export const TakeActionWrapper: CSSObject = {
  px: '2',
  color: 'black',
};
